import { StyledKicker } from '../../../../cards/Kicker/Kicker.styled'
import { calcRem } from '../../../../__styling/style-functions/calc-rem'
import styled from '@emotion/styled'
import { IconPlay } from '../../../../icons/IconPlay/IconPlay'
import { colors } from '../../../../__styling/settings/colors'
import { breakpointMax } from '../../../../__styling/style-functions'
import { StyledLiveBubble } from '../../../../typography/EditorialLabel/EditorialLabel.styled'

export const RestyledPlayIcon = styled(IconPlay)<{ height: number }>(
    ({ height }) => ({
        height: calcRem(height),
        width: calcRem(1.5 * height),
        fill: colors.white,
        paddingRight: calcRem((height * 2) / 3),
    }),
)

export const RestyledKicker = styled(StyledKicker)<{ iconHeight: number }>({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    top: 'auto',
    bottom: calcRem(6),

    '&:hover, &:active, &:focus': {
        background: colors.sevennews.blueRibbon,
    },

    [breakpointMax('xs')]: {
        display: 'flex',
    },
})

export const StyledLive = styled(StyledLiveBubble)({
    marginLeft: calcRem(9),
})

export const StyledDuration = styled('span')<{ iconHeight: number }>(
    ({ iconHeight }) => ({
        paddingLeft: calcRem((iconHeight * 2) / 3),
        fontWeight: 400,
        minWidth: '2.5em',
    }),
)
